import Lottie from 'react-lottie';
import { useState } from 'react';
import loadingAnimation from '../../common/lotties/loading.json';

interface Props {
    height?: number;
    width?: number;
}

const PargodaLoading = ({ height = 400, width = 400 }: Props) => {
    const [key, setKey] = useState(0); // This will force remount
    const [isPaused, setIsPaused] = useState(false);

    const loadingOptions = {
        loop: false,
        autoplay: true,
        animationData: loadingAnimation,
    };

    const handleComplete = () => {
        setIsPaused(true);
        setTimeout(() => {
            setIsPaused(false);
            setKey((prev) => prev + 1); // Force remount to restart animation
        }, 1000); // 5 seconds pause
    };

    return (
        <Lottie
            key={key} // This forces a fresh component mount when key changes
            options={loadingOptions}
            height={height}
            width={width}
            speed={2}
            isPaused={isPaused}
            eventListeners={[
                {
                    eventName: 'complete',
                    callback: handleComplete,
                },
            ]}
        />
    );
};

export default PargodaLoading;
